
import { useState } from "react";
import { Search, Loader2, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface SeoSearchFormProps {
  url: string;
  setUrl: (url: string) => void;
  analyzing: boolean;
  urlError: string | null;
  handleSubmit: (e: React.FormEvent) => void;
  selectedTool: string;
}

export const SeoSearchForm = ({ 
  url, 
  setUrl, 
  analyzing, 
  urlError, 
  handleSubmit,
  selectedTool 
}: SeoSearchFormProps) => {
  return (
    <form onSubmit={handleSubmit} className="mb-6">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-grow">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Enter your website URL (e.g., example.com)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={`pl-10 ${urlError ? 'border-red-500' : ''}`}
          />
          {urlError && (
            <div className="absolute left-0 right-0 -bottom-9 flex items-center gap-1.5 text-red-500 text-sm">
              <AlertCircle className="h-4 w-4" />
              <span>{urlError}</span>
            </div>
          )}
        </div>
        <Button 
          type="submit" 
          disabled={analyzing}
          className="bg-desert-sunset hover:opacity-90 transition-opacity whitespace-nowrap"
        >
          {analyzing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Analyzing...
            </>
          ) : (
            "Analyze Now"
          )}
        </Button>
      </div>
    </form>
  );
};

export default SeoSearchForm;
